import { render, staticRenderFns } from "./orderrecordmanagement.vue?vue&type=template&id=231daeb8&scoped=true"
import script from "./orderrecordmanagement.vue?vue&type=script&lang=js"
export * from "./orderrecordmanagement.vue?vue&type=script&lang=js"
import style0 from "./orderrecordmanagement.vue?vue&type=style&index=0&id=231daeb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231daeb8",
  null
  
)

export default component.exports